<!--
 * @FileDescription: 文件模板（注释描述）
 * @Author:xy（作者）
 * @Date: 2020-04-15（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-15（最后更新时间）
 -->
<template>
  <div class="a-popover-upload">
    <a-row style="margin-top:5px" v-if="isUpload">
      <a-col style="width:216px">
        <span class="label-title">单据附件</span>
        <div class="file-upload">
          <input type="file" id="input" ref="thumbnail" @change="onImage" multiple="multiple" />
          <a-icon type="upload" class="file-icon" />
          <span>上传附件</span>
        </div>
      </a-col>
    </a-row>
    <a-row style="margin-bottom: -15px" v-else>
      <a-col>
        <span>单据附件：</span>
      </a-col>
    </a-row>
    <a-row class="upload-list">
      <a-col v-for="(item,index) in fileUrl" :key="index">
        <div class="icon-name" @click="lookImage(item)">
          <a-icon type="link" />
          <span>{{item.resource_name}}</span>
        </div>
        <img src="@/assets/image/cha_shanchu_color.png" alt="" style="width:16px" @click="onDelete(item, index)">
      </a-col>
    </a-row>
  </div>
</template>
<script>
import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer/src/component.vue"
import { uploadMultiFile, downFile } from "@/utils/api";
import axios from 'axios'
export default {
  props: {
    index: {
      type: Number,
      default: 9
    },
    fileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isUpload: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Viewer
  },
  data () {
    return {
      fileUrl: [],
      imgIndex: 0,
      imgUrl: ''
    }
  },
  methods: {
    /**
     * @description: 此为方法注释（方法描述）
     * @param {参数类型} 参数名称
     * @return void
     */
    onImage () {
      //   this.fileUrl = []
      let index = ''
      let imageFile = this.$refs.thumbnail.files
      var form = new FormData()
      if (imageFile.length > 0) {
        for (let i = 0; i < imageFile.length; i++) {
          if (imageFile[i].size > 1024 * 1024) {
            index++
            this.$message.warn('文件过大')
          } else {
            form.append("file", imageFile[i])
          }
        }
        if (index !== imageFile.length) {
          $('#input').val('')
          form.append("type", "store")
          uploadMultiFile(form, {
            'Content-Type': 'multipart/form-data'
          }).then((res) => {
            if (res.success) {
              res.result.map(item => {
                this.fileUrl.push(item)
              })
              this.imgIndex = res.result.length
              this.$message.success(res.logMessage)
              this.$emit('onChangeFile', this.fileUrl)
            } else {
              this.$message.warn(res.logMessage)
              if (res.result.length > 0) {
                res.result.forEach((item) => {
                  if (item.success == 'true') {
                    this.fileUrl.push(item)
                  }
                })
                this.imgIndex = this.fileUrl.length
              }
              this.$emit('onChangeFile', this.fileUrl)
            }
          })
        }
      }
    },
    onDelete (item, index) {
      this.$comm.removeByIndex(this.fileUrl, index)
      this.$emit('onChangeFile', this.fileUrl)
    },
    lookImage (item) {
      axios({
        method: 'get',
        url: '/resource/downloadApi/getOutputStreamByFilePathAndName',
        data: {
        },
        params: {
          filePathAndName: item.resource_url
        },
        headers: {},
        responseType: 'blob'
      }).then((res) => {
        let url = window.URL.createObjectURL(new Blob([res.data], { type: "application/vnd.ms-excel" }))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', item.resource_name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
    }
  },
  mounted () {
    this.fileUrl = []
    this.fileList.map(item => {
      this.fileUrl.push({
        resource_url: item.resourceUrl,
        success: true,
        orderId: item.id,
        resource_name: item.resourceName,
        suffixName: item.suffixName,
        resourceId: item.resourceId
      })
    })
    setTimeout(() => {
    //   console.log(this.fileList, this.fileUrl)
    }, 500)
  },
  watch: {
    fileList () {
      if (this.fileList.length <= 0) {
        this.fileUrl = []
      } else {
        this.fileUrl = []
        this.fileList.map(item => {
          this.fileUrl.push({
            resource_url: item.resourceUrl,
            success: true,
            orderId: item.id,
            resource_name: item.resourceName,
            suffixName: item.suffixName,
            resourceId: item.resourceId
          })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.a-popover-upload {
  margin-top: 15px;
  .file-upload {
    cursor: pointer;
    width: 120px;
    height: 36px;
    border: 1px solid rgba(247, 111, 20, 1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--co);
    position: relative;
    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 120px;
      height: 36px;
      display: inline-block;
      opacity: 0;
    }
    .file-icon {
      font-size: 16px;
      color: var(--co);
      margin-right: 14px;
    }
  }
  .upload-list {
    .icon-name {
      width: 200px;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 14px;
      }
    }
  }
}
</style>
